import React, { useEffect, useState } from "react";
import { apiGet } from "components/Common/Axios";
import toast from "react-hot-toast";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { VatCompany } from "lib/models";
import VatCompanyEditPopup from "./VatCompanyEditPopup";

const VatCompanyList = ({
  currentVatCompanyId,
  onSelectVatCompany,
  popupLevel,
}: {
  currentVatCompanyId: number;
  onSelectVatCompany: (vatCompany: VatCompany) => void;
  popupLevel: number;
}) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [isAddMode, setIsAddMode] = useState<boolean>(false);
  const [vatCompanyList, setVatCompanyList] = useState<VatCompany[]>([]);
  const [searchKeyword, setSearchKeyword] = useState<string>("");
  const [selectedVatCompany, setSelectedVatCompany] = useState<
    VatCompany | undefined
  >(undefined);
  const [filteredVatCompanyList, setFilteredVatCompanyList] = useState<
    VatCompany[]
  >([]);

  const loadVatCompanyList = async () => {
    const response = await apiGet("/invoice/company-list");

    if (response.error) {
      toast.error("세금계산서 발급처 정보를 불러오는데 실패했습니다.");
      console.error("loadVatCompanyList error", response.error);
      return;
    }
    setVatCompanyList(response.data);
  };

  const handleAdd = () => {
    setIsAddMode(true);
    setSelectedVatCompany(undefined);
    setOpenEdit(true);
  };

  const handleEdit = (vatCompany: VatCompany) => {
    setIsAddMode(false);
    setSelectedVatCompany(vatCompany);
    setOpenEdit(true);
  };

  const handleSearchChange = (search: string) => {
    setSearchKeyword(search);
  };

  useEffect(() => {
    loadVatCompanyList();
  }, []);

  useEffect(() => {
    setFilteredVatCompanyList(
      vatCompanyList.filter((vatCompany) =>
        vatCompany.nickName.includes(searchKeyword)
      )
    );
  }, [searchKeyword, vatCompanyList]);

  return (
    <div className="pb-10">
      <VatCompanyEditPopup
        open={openEdit}
        onOpenChange={setOpenEdit}
        isAdd={isAddMode}
        selectedVatCompany={selectedVatCompany}
        vatCompanyList={vatCompanyList}
        setVatCompanyList={setVatCompanyList}
        popupLevel={popupLevel}
      />
      <div className="flex flex-wrap justify-between items-center gap-2">
        <Button variant="primary" size="lg" onClick={() => handleAdd()}>
          추가
        </Button>
        <div>
          <Input
            value={searchKeyword}
            placeholder="검색어를 입력하세요"
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
      </div>
      <div className="overflow-x-auto"><div className="min-w-[1300px]">
      <div className="py-2 mt-3 text-sm text-left grid items-center grid-cols-[30px_140px_160px_140px_80px_1fr_250px_120px_120px_140px_80px] bg-gray-200">
        <div></div>
        <div>이름</div>
        <div>단체명</div>
        <div>고유번호</div>
        <div>대표자</div>
        <div>소재지</div>
        <div>이메일</div>
        <div>업태</div>
        <div>업종</div>
        <div>입금자명</div>
        <div></div>
      </div>
      {filteredVatCompanyList.map((vatCompany) => (
        <div
          key={vatCompany.id}
          className="py-2 border-b border-solid border-gray-300 text-sm text-left grid items-center grid-cols-[30px_140px_160px_140px_80px_1fr_250px_120px_120px_140px_80px] cursor-pointer hover:bg-gray-50"
          onClick={() => onSelectVatCompany(vatCompany)}
        >
          <div>
            {currentVatCompanyId === vatCompany.id && (
              <div className="text-center">✓</div>
            )}
          </div>
          <div>{vatCompany.nickName}</div>
          <div>{vatCompany.name}</div>
          <div>{vatCompany.businessNo}</div>
          <div>{vatCompany.ceoName}</div>
          <div>{vatCompany.address}</div>
          <div>{vatCompany.email}</div>
          <div>{vatCompany.bussinessType}</div>
          <div>{vatCompany.bussinessItem}</div>
          <div>{vatCompany.depositName}</div>
          <div>
            <Button
              onClick={(e) => {
                e.stopPropagation();

                handleEdit(vatCompany);
              }}
              variant="primary"
              size="sm"
            >
              편집
            </Button>
          </div>
        </div>
      ))}
      </div></div>
    </div>
  );
};

export default VatCompanyList;
